import * as Sentry from '@sentry/vue'
import { config } from './config'
import { getPipelineId } from '@/utils/environment'

type SentryInitParams = {
  app: NonNullable<Parameters<typeof Sentry.init>['0']>['app']
  router: Parameters<(typeof Sentry)['vueRouterInstrumentation']>['0']
}

const sentryDsn = config.global.SENTRY_DSN

export function init({ app, router }: SentryInitParams) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    release: getPipelineId(),
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
  })
}

export function captureException(error: any) {
  Sentry.captureException(error)
}

export default {
  init,
  captureException,
}
